import { ACTION_CONST } from "../../constants";

const INITIAL_STATE = {
  tokens: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTION_CONST.GET_TOKENS_SUCCESS:
      return {
        ...state,
        tokens: action.data
      };
    default:
      return state;
  }
};
